module.exports = __webpack_public_path__ + "03_long_brown.d9d5c972.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_long_brown.png
// module id = nQw8
// module chunks = 0